export default __webpack_public_path__ + "static/SourceSansPro-SemiBold-ea12a4c1226398200b27cbf53a4cec1c.woff2";